const mapDetailProviderData = (fields = [], providerDetails) => {
  const extendedFields = [];

  fields.forEach((field, i) => {
    const updatedField = { ...field };

    switch (field.name) {
      case "slot_availability_info":
        const slotAvailabilityInfopropName = updatedField.name
          .replace("_info", "")
          .replace(/_([a-z])/g, g => g[1].toUpperCase());
        updatedField.title =
          providerDetails[slotAvailabilityInfopropName] || "";
        if (updatedField.title.startsWith("(")) {
          const index = updatedField.title.indexOf(" ");
          updatedField.title = updatedField.title.slice(index + 1);
        }
        updatedField.title = updatedField.title.replace(/, /g, "\n");
        break;
      case "profile_image":
        updatedField.url = providerDetails.profile_image;
        break;
      case "name":
        updatedField.title = providerDetails.name;
        break;
      case "role_info":
      case "location_info":
      case "education_info":
      case "languages_info":
      case "gender_info":
      case "bio_info":
      case "availability_info":
      case "unavailabilities_info":
      case "provider_specialties_info":
      case "provider_credentials_info":
      case "vpcp_role_info":
      case "website_url_info":
      case "special_training_info":
      case "out_of_office_dates_info":
      case "provider_availabilities_info":
        updatedField.title =
          providerDetails[updatedField.name.replace("_info", "")];
        break;
      default:
    }

    if (field.name === "website_url_info") {
      updatedField.links = [
        {
          range: "",
          string: updatedField.title,
          url: updatedField.title,
          target_blank: true,
          webLink: updatedField.title
        }
      ];
      updatedField.params = "TDFieldOptionAutoCorrectNone";
    }

    if (
      updatedField.name.includes("info") &&
      (!updatedField.title || updatedField.title.length === 0)
    ) {
      extendedFields[i - 1].title = "";
    }

    extendedFields[i] = updatedField;
  });

  return extendedFields;
};

export const sortFields = fields => {
  const order = [
    "name",
    "profile_image",
    "role_info",
    "gender",
    "gender_info",
    "languages",
    "languages_info",
    "provider_specialties",
    "provider_specialties_info",
    "provider_credentials",
    "provider_credentials_info",
    "slot_availability",
    "slot_availability_info",
    "unavailabilities",
    "unavailabilities_info",
    "special_training",
    "special_training_info",
    "education",
    "education_info",
    "website_url",
    "website_url_info",
    "bio",
    "bio_info"
  ];

  const orderedFields = fields
    .filter(field => order.includes(field.name))
    .sort((a, b) => {
      const aIndex = order.indexOf(a.name);
      const bIndex = order.indexOf(b.name);
      return aIndex - bIndex;
    });

  const unorderedFields = fields.filter(field => !order.includes(field.name));

  return [...orderedFields, ...unorderedFields];
};

export default mapDetailProviderData;
